import { render, staticRenderFns } from "./TypeWashes.vue?vue&type=template&id=a6367824&scoped=true&"
import script from "./TypeWashes.vue?vue&type=script&lang=js&"
export * from "./TypeWashes.vue?vue&type=script&lang=js&"
import style0 from "./TypeWashes.vue?vue&type=style&index=0&id=a6367824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6367824",
  null
  
)

export default component.exports